import { c as _c } from "react/compiler-runtime";
import { InfoTooltip } from '@cc-shopping/ui/composites/InfoTooltip';
import { Box } from '@mui/material';
export function Mobile(t0) {
  const $ = _c(8);
  const {
    creditOrCreditScoreLabel
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: {
        xs: "flex",
        md: "none"
      },
      alignItems: "center",
      gap: 1
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = `Rec. ${creditOrCreditScoreLabel}`;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      height: "20px"
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = `Recommended ${creditOrCreditScoreLabel}`;
  const t5 = `Recommended ${creditOrCreditScoreLabel}`;
  let t6;
  if ($[2] !== t4 || $[3] !== t5) {
    t6 = <InfoTooltip position="bottom" minHeight={0} minWidth={0} containerStyles={t3} triggerIconHeight={18} triggerIconWidth={18} text={t4} ariaLabel={t5} tooltipPadding="10px 16px" />;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t2 || $[6] !== t6) {
    t7 = <Box sx={t1}>{t2}{t6}</Box>;
    $[5] = t2;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  return t7;
}